import { render, staticRenderFns } from "./base-comparaison-legende.vue?vue&type=template&id=f5fa57f4"
import script from "./base-comparaison-legende.vue?vue&type=script&lang=js"
export * from "./base-comparaison-legende.vue?vue&type=script&lang=js"
import style0 from "./base-comparaison-legende.vue?vue&type=style&index=0&id=f5fa57f4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports